import React, {useState} from 'react';
import OpenModalSelectBillItemToPrint from "./Modals/OpenModalSelectBillItemToPrint"

const IsAccountingTable = ({selectedRow, entityName, selectType}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="btn btnFixedOverWrite"
        onClick={() => setIsOpen(true)}
        disabled={selectedRow === undefined}
      > صورتحساب حسابداری
      </button>
      {isOpen &&
        <>
          <OpenModalSelectBillItemToPrint
            selectedRow={selectedRow}
            isOpen={setIsOpen}
            modalCallback={() => setIsOpen(false)}
            entityName={entityName}
            selectType={selectType}
          />
        </>
      }


    </>
  );
};

export default IsAccountingTable;
